import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75f403aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Tidningsinnehåll", -1))
const _hoisted_2 = { class: "row mt-3 mb-3" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "input-group mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" })
], -1))
const _hoisted_8 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_9 = { class: "filter-header" }
const _hoisted_10 = { class: "diplay: inline-block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_12 = { class: "filter-header" }
const _hoisted_13 = { class: "diplay: inline-block" }
const _hoisted_14 = { class: "filter-header" }
const _hoisted_15 = { class: "diplay: inline-block" }
const _hoisted_16 = { class: "filter-header" }
const _hoisted_17 = { class: "diplay: inline-block" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Utgåva"),
  /*#__PURE__*/_createElementVNode("th", null, "Titel"),
  /*#__PURE__*/_createElementVNode("th", null, "Storlek"),
  /*#__PURE__*/_createElementVNode("th", null, "Status"),
  /*#__PURE__*/_createElementVNode("th", null, "Ansvarig"),
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_20 = { class: "btn-group" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-edit" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_multi_filter_selector = _resolveComponent("multi-filter-selector")!
  const _component_sorter_direction = _resolveComponent("sorter-direction")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary btn-sm",
          to: "/mgmt/content/create"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Lägg till innehåll")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-sm",
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterApplied && _ctx.filterApplied(...args))),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.textfilter) = $event))
          }, null, 544), [
            [_vModelText, _ctx.filters.textfilter]
          ])
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_8, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_multi_filter_selector, {
                items: _ctx.contents,
                field: "editionName",
                selected: _ctx.filters.editionName,
                onChanged: _ctx.filterApplied
              }, null, 8, ["items", "selected", "onChanged"]),
              _createVNode(_component_sorter_direction, {
                onChanged: _ctx.sortOrderApplied,
                field: "editionName",
                sorting: _ctx.sorting
              }, null, 8, ["onChanged", "sorting"])
            ])
          ]),
          _hoisted_11,
          _createElementVNode("th", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_sorter_direction, {
                onChanged: _ctx.sortOrderApplied,
                field: "contentSize",
                sorting: _ctx.sorting
              }, null, 8, ["onChanged", "sorting"])
            ])
          ]),
          _createElementVNode("th", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_multi_filter_selector, {
                items: _ctx.contents,
                field: "status",
                selected: _ctx.filters.status,
                onChanged: _ctx.filterApplied
              }, null, 8, ["items", "selected", "onChanged"]),
              _createVNode(_component_sorter_direction, {
                onChanged: _ctx.sortOrderApplied,
                field: "status",
                sorting: _ctx.sorting
              }, null, 8, ["onChanged", "sorting"])
            ])
          ]),
          _createElementVNode("th", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_multi_filter_selector, {
                items: _ctx.contents,
                field: "responsible",
                selected: _ctx.filters.responsible,
                onChanged: _ctx.filterApplied
              }, null, 8, ["items", "selected", "onChanged"]),
              _createVNode(_component_sorter_direction, {
                onChanged: _ctx.sortOrderApplied,
                field: "responsible",
                sorting: _ctx.sorting
              }, null, 8, ["onChanged", "sorting"])
            ])
          ]),
          _hoisted_18
        ]),
        _hoisted_19
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredContent, (content, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, _toDisplayString(content.editionName), 1),
            _createElementVNode("td", null, _toDisplayString(content.title), 1),
            _createElementVNode("td", null, _toDisplayString(content.contentSize), 1),
            _createElementVNode("td", null, _toDisplayString(content.status), 1),
            _createElementVNode("td", null, _toDisplayString(content.responsible), 1),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.editContent(content.contentId)),
                  class: "btn btn-sm btn-primary",
                  title: "Ändra innehåll"
                }, _hoisted_23, 8, _hoisted_21),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.deleteContent(content)),
                  class: "btn btn-sm btn-danger",
                  title: "Ta bort innehåll"
                }, _hoisted_26, 8, _hoisted_24)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}